export const name: string = 'Period Filter';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-filter-period';
export const icon: string = 'calendar';
export const namespace: string = 'business-intelligence';
export const priority: number = 10; //for Taras: priority of order if widgets loading in WS, higher=first, default=0
export const themeId: string = 'widget-filter-period'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)

export const MONTHS = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
